import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

export interface MeliAttribute{
  attribute_group_id?:string;
  attribute_group_name?:string;
  example?:string;
  hierarchy?:string;
  hint?:string;
  id:string;
  name:string;
  relevance:number;
  tags:Object;
  tooltip:string;
  value_max_length:number;
  value_type:string;
  values:AttributeValueList[]
  allowed_units?:AllowedUnitsList[];
  default_unit?:string;
  value_id?:string;
  value_name?:string;
  value_unit?:string;
  editing:boolean;
  notAplicable:boolean;
}

export interface AttributeValueList{
  name:string;
  id:string;
}

export interface AllowedUnitsList{
  name:string;
  id:string;
}
					


@Component({
    selector: 'app-meli-attribute',
    templateUrl: './meli-item-attrib.component.html',
    styleUrls: ['./meli-item-attrib.component.scss'],
    standalone: false
})
export class MeliItemAttribComponent implements OnInit {

  attribValidator:AbstractControl[] = [];
  attribs:MeliAttribute[] = [];
  attribsTemp:MeliAttribute[] = [];
  buttonList:ButtonList[] = [];
  data:GenericEdit;
  mainFormGroup:UntypedFormGroup;
  row:Object = [];
  product:Object;
  @Output() saving:EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter();

  constructor(private http:HTTPService, private uid:UserAuthenticationServices, private cd:ChangeDetectorRef,
    private spinner:NgxSpinnerService,
    public ThemeService:ThemeService,
    private snackBar:SnackbarService,
    private dynamicServices:DynamicFormsService) { }

  ngOnInit(): void {


    this.buttonList.push({
      color:"primary",
      description:"Salvar",
      action: ()=>{
          this.okFunction();
      }
    },
    {
      color:"warn",
      description:"Cancelar",
      action: ()=>{
          this.cancelFunction();
      }
    })

    this.product = this.data['parentRow']['linha'];
    this.mainFormGroup = this.data.formGroup;
    
    this.buscarAtributos().then(meliresult=>{
      this.initialize(meliresult,this.product).finally(()=>{this.spinner.hide('meliitemcontainerattrib')});
    }).finally(()=>{
      this.spinner.hide('meliitemcontainerattrib')
    })
    
    
  }

  initialize(meliresult, product){

    return new Promise(async (resolve,reject)=>{
      if ( ObjectUtil.isNotEmpty(meliresult)){

        try{
          let dataAttrib = JSON.parse(JSON.stringify(meliresult));
          
          if ( ObjectUtil.isNotEmpty(dataAttrib)){
            if (  ObjectUtil.isNotEmpty(dataAttrib)){
                this.attribs = dataAttrib;
                this.attribsTemp = dataAttrib;
  
                await this.getAttributeData(product).then(data=>{
                    let mktpmeliattrib  = data as Object[];
                    if ( ObjectUtil.isNotEmpty(mktpmeliattrib) ){
  
                      if ( mktpmeliattrib.length > 0 ){
                          for ( var item of mktpmeliattrib){
                              if (  item['VALUE_ID'] != null ) {
                                let itemAttrib = this.attribs.find(a=>a.id  == item['ID_ATRIBUTO']);
                                
                                if ( ObjectUtil.isNotEmpty(itemAttrib)){
                                  if ( itemAttrib.value_id != item['VALUE_ID'] || itemAttrib.value_unit != item['VALUE_UNIT'] ){
                                    itemAttrib.value_id = item['VALUE_ID'];
                                    itemAttrib.value_unit = item['VALUE_UNIT'];
                                    itemAttrib.value_name = this.getValueName( itemAttrib );
                                    itemAttrib.editing = true;
                                    if ( item['VALUE_ID'] == -1){
                                      itemAttrib.notAplicable = true;
                                    }
                                  }
                                  
                                }
                              }   
                          }

                        this.cd.markForCheck();
                        resolve(true);
                        return;
                      }
                    }else{
                      this.cd.markForCheck();
                      resolve(true);
                      return;
                    }
                });
              
            }
          }
          this.cd.markForCheck();
          resolve(true);
  
        }catch(Exception){
          
        }
      }else{
        resolve(true);
      }
    });
    
  }

  isRequired(item:object, type:string){

    if ( type == "A"){
      if ( item['hierarchy']=='PARENT_PK'){
        return true;
      }
    }

    return false;
  }

  openDataOption(item){
      
    item['ID_ATRIBUTO'] = item.id;
    item['IDATRIBUTO'] = item.id;
    this.dynamicServices.getDataFromTable(item, 'value_id','',this.mainFormGroup,'AttibValueErp','text' )
 }


  deleteItem(item:MeliAttribute){
      let index = this.attribsTemp.findIndex(i=>i.id == item.id);
      this.attribsTemp.splice(index,1);

      // let indexTemp = this.attribsTemp.findIndex(i=>i.id == item.id);
      // this.attribsTemp.splice(indexTemp,1);
  } 

  onNotAplicable(evento,item:MeliAttribute){
    
      item.editing = true;
      if  ( item.notAplicable ){
        item.value_id = '-1';
        item.value_name = null;
      }else{
        item.value_id = null;
        item.value_name = null;
      }
      
  }
  
  onBlur(item:MeliAttribute){
      
  }

  okFunction(){
    this.salvar(this.product); 
  }

  cancelFunction(){
    this.saving.emit({changing:false,keepOpen:false});
  }
  

  checkAtribVar(item){
    
    if ( ObjectUtil.isNotEmpty(item['tags']) ){
      if ( ObjectUtil.isNotEmpty(item['tags']['allow_variations'])){
        let allow_variations  = item['tags']['allow_variations'];
          if( allow_variations){
            return true;
          }else{
            return false;
          }
      }else{
        return false;
      }
    }else{
      return false;
    }
  }


  updateFilter(event) {
    
    const filterValue = (event.target as HTMLInputElement).value;

    this.attribs= this.attribsTemp.filter((data) => {
      return data.name.toUpperCase().indexOf(filterValue.toUpperCase()) > -1 ? true : false
      || data.hint != null ? data.hint.toUpperCase().indexOf(filterValue.toUpperCase())>-1 ? true : false:  false
      || data.tooltip != null ? data.tooltip.toUpperCase().indexOf(filterValue.toUpperCase())>-1 ? true : false : false
    });

  }

  async getAttributeData(product:Object){

    return await new Promise((resolve,reject)=>{
      let local = {
        entityName: 'Mktpmeliatrib',
        showImageData:false,
        showImagaDataBase64:false,
        showPresentation:false,
        showRelationshipData:false,
        showRelationship:false,
        condition: `codecompany=${product['CODECOMPANY']} and codeproduct=${product['CODEPRODUCT']} and codemeli=${product['CODEMELI']}`
      }
  
      this.http.post(local,'JsonBrokerServices/find',false,true,true).subscribe(result=>{
        resolve(result['Mktpmeliatrib'] as Object[]);
      },(error)=>{
          throw error;
      });
    })
  }    


  prepareData(product:Object):Object[]{
      let dataObject:Object[] = [];

      //for ( var data of this.attribs.filter(d=>d.editing==true) ){
      for ( var data of this.attribs ){
          let ob = {};
          ob['CODECOMPANY'] = product['CODECOMPANY'];
          ob['CODECONTRACT'] = product['CODECONTRACT'];
          ob['CODEPRODUCT'] = product['CODEPRODUCT'];
          ob['CODEMELI'] = product['CODEMELI'];
          
          Object.keys(data).forEach(col=>{
            if ( col == 'id'){
              ob["ID_ATRIBUTO"] =data[col] != null ?  data[col].toString() : null;
            }else
            if ( col == 'name'){
              ob["DESCRATRIB"] =data[col] != null ?  data[col].toString() : null;
            }else
            if ( col == 'values'){
              ob["OPTIONS"] = data[col]!= null ? JSON.stringify(data[col]) : null;
            }else
            if ( col == 'value_id'){
              ob["VALUE_NAME"] = this.getValueName(data);
              ob["VALUE_ID"] =  data[col] != null ? data[col].toString() : null;
            }
            else{
              if ( col!='value_name'){
                if ( data[col] instanceof Array || data[col] instanceof Object ){
                  ob[col.toUpperCase()] = data[col] != null ? JSON.stringify(data[col]) : null;
                }else{
                  ob[col.toUpperCase()] = data[col] != null ? data[col].toString() : null;
                }
              }
              
            }            
          });

          dataObject.push(ob);
      }

      return dataObject;
  }

  getValueName(data: MeliAttribute): any {
 
     if (data['values'] == null){
      return null;
     }
     
     let values:AttributeValueList[] = data['values'];
     
     let value:AttributeValueList =  values.find(d=>d.id == data.value_id);
     
     if ( value == null ){
      return null;
     }
     return value.name;
  }

  salvar(product){
    this.spinner.show('meliitemcontainerattrib');
    
    let local = {
      entityName: 'Mktpmeliatrib',
      remove:true,
      removeCondition: `codecompany=${product['CODECOMPANY']} and codeproduct=${product['CODEPRODUCT']} and codemeli=${product['CODEMELI']}`,
      data: this.prepareData(product)
    }

    this.http.post(local,'JsonBrokerServices/save',false,true,true).subscribe(result=>{
        this.snackBar.showSuccess("Atributos importados com sucesso.");
        this.saving.emit({changing:true,keepOpen:false});
        this.spinner.hide('meliitemcontainerattrib'); 
    },(error)=>{
        this.spinner.hide('meliitemcontainerattrib');
        throw error;
    });
  }

  buscarAtributos(){

  return new Promise((resolve,reject)=>{
      if ( !ObjectUtil.isNotEmpty(this.product["CATEGORY_ID"]) ){
        this.snackBar.showError("Não informado o código de categoria.");
        this.spinner.show("meliitemcontainerattrib");
        return;
    }

    
    let ob = {
      codeCompany : this.product["CODECOMPANY"],
      method: "GET",
      serviceName: "FindAttribByCat",
    }

    ob['params']=[{
        key:"@CATEGORYID",
        value:this.product["CATEGORY_ID"]
    }];

    
    this.spinner.show("meliitemcontainerattrib");
    
    this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
        this.attribValidator = [];    
        let tempAttrib:Object[] = data['resultado'];
        resolve(tempAttrib);
      },error=>{
        this.spinner.hide("meliitemcontainerattrib");
        throw error;
      });
    })
  }

  onModelChange(item:MeliAttribute){
      if ( item.value_id != null  && item.value_id !="" ){
        item.editing = true;
      }

      if ( item.value_unit != null  && item.value_unit !="" ){
        item.editing = true;
      }

      if ( item.value_id == "" ){
        item.editing = false;
      }


  }
  
}
